import { FlexyForm, FormStructure } from '@europrocurement/flexy-form';
import { Box, Button, useTheme } from '@mui/material';
import React from 'react';
import { FieldValues, SubmitHandler, useForm } from 'react-hook-form';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { SignableDocumentRecipient } from '../../../../providers/types';

export type RecipientFormProps = {
    onAddRecipient: (recipients: SignableDocumentRecipient) => void;
    onCancel?: () => void;
};

export type RecipientFormData = {
    firstName: string;
    lastName: string;
    email: string;
    mobile: string;
};

const RecipientForm: React.FunctionComponent<RecipientFormProps> = function (props) {
    const { onAddRecipient, onCancel } = props;

    const { palette } = useTheme();

    const spacer = {
        type: 'customItem' as const,
        name: 'spacer',
        renderField: () => <Box sx={{ marginY: '20px' }} />,
    };

    const formStructure: FormStructure[] = [
        {
            type: 'text',
            name: 'firstName',
            label: 'Prénom',
            md: 6,
            lg: 6,
            rules: {
                required: 'Ce champ est requis',
            },
        },
        {
            type: 'text',
            name: 'lastName',
            label: 'Nom',
            md: 6,
            lg: 6,
            rules: {
                required: 'Ce champ est requis',
            },
        },
        spacer,
        {
            type: 'text',
            name: 'email',
            label: 'Email',
            md: 6,
            lg: 6,
            rules: {
                required: 'Ce champ est requis',
            },
        },
        {
            type: 'text',
            name: 'mobile',
            label: 'Téléphone mobile',
            md: 6,
            lg: 6,
            rules: {
                required: 'Ce champ est requis',
            },
        },
    ];

    const formContext = useForm<FieldValues>({
        mode: 'onChange',
    });

    const handleSubmit: SubmitHandler<RecipientFormData> = (formData: RecipientFormData) => {
        onAddRecipient(formData as SignableDocumentRecipient);
        formContext.reset();
    };

    const formProps = {
        formContext,
        onSubmit: handleSubmit,
        submitButton: {
            displayed: false,
        },
    };

    return (
        <>
            <FlexyForm
                formStructure={formStructure}
                {...formProps}
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', columnGap: '1em' }}>
                {onCancel && (
                    <Button
                        variant="text"
                        onClick={onCancel}
                        sx={{ color: palette.primary.dark }}
                    >
                        Annuler
                    </Button>
                )}
                <Button
                    variant="contained"
                    onClick={formContext.handleSubmit(handleSubmit)}
                    sx={{
                        display: 'flex',
                        columnGap: '0.5em',
                        padding: '16px 24px',
                        background: palette.primary.dark,
                    }}
                >
                    <FaOptionIcon
                        icon={['fas', 'plus']}
                        sx={{ lineHeight: 0 }}
                    />
                    Ajouter le destinataire
                </Button>
            </Box>
        </>
    );
};

export default RecipientForm;
